import React, { useContext, useEffect, useState } from 'react';
import LocationInfo from './LocationInfo';
import SideBarLayout from '../../../global/layout/SideBarLayout';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { makeDeleteCall, makeGetCall, makeNextPageCall, makePostCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType, SubTab } from '../../../types';
import { emptyFunction, getCompanyName, handleTabs, showToast } from '../../../utils';
import DetailsHeaderTabs, { TopTab } from './DetailsHeaderTabs';
import UpdateLocation from './UpdateLocation';
import UpdateCrib from './UpdateCrib';
import DeleteCribSheetPopup from './DeleteCribSheetPopup';
import { canViewLocation } from '../../../data/data';
import AddTagsPopUp from './AddTagsPopUp';
import AsignLocationToProd from '../locationVault/AsignLocationToProd';
import { toast } from 'react-toastify';
import AsignLocationToCollection from '../collections/AsignLocationToCollection';
import { MyContext } from '../../../context';
import CreateCollections from '../collections/CreateCollections';
import AsignLocationToPerScript from '../perScript/AsignLocationToPerScript';

const LocationDetail: React.FC<any> = (props) => {

    const params = useParams();
    const { state } = useLocation();

    const { userData } = useContext(MyContext)

    const navigate = useNavigate();

    const locationId = params?.id || '';
    const location = state?.location;
    const vaultType = params?.type || '';

    const [topTab, setTopTab] = useState<TopTab>('about');
    const [locationData, setLocationData] = useState<any>(location);
    const [locationVaultId, setLocationVaultId] = useState<any>('');
    const [subTab, setSubTab] = useState<SubTab>('info');
    const [cribsEnteries, setCribsEnteries] = useState<Array<any>>([]);
    const [nextUrl, setNextUrl] = useState<string | null>(null);
    const [editLocationData, setEditLocationData] = useState<any>(null)
    const [editCribData, setEditCribData] = useState<any>(null)
    const [deleteCribData, setDeleteCribData] = useState<any>(null)
    const [showTagsModal, setShowTagsModal] = useState<any>(false)
    const [showAddProd, setShowAddProd] = useState<any>(false)
    const [asignLocCollection, setAsignLocCollection] = useState<any>(null);
    const [asignLocToScript, setAsignLocToScript] = useState<any>(null);
    const [showCreateCollection, setShowCreateCollection] = useState(false);

    const fetchLoc = () => {
        const url = `${endPoints.LOCATION_VAULT}${locationId}/`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setLocationData(res?.data?.location || location);
                setLocationVaultId(res?.data?.id)
                setEditLocationData(null);
                setShowTagsModal(false)
                setShowAddProd(false)
            }
        }).catch(emptyFunction)
    }

    const fetchLocCribs = () => {
        makeGetCall(endPoints.LOCATION_CRIB, { location_id: locationData?.id }).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                setCribsEnteries(res?.results?.length > 0 ? res?.results : []);
                setNextUrl(res?.next || null);
                setEditCribData(null);
                setDeleteCribData(null);
            }
        }).catch(emptyFunction)
    }

    const handleDelete = () => {
        const url = `${endPoints.LOCATION_CRIB}${deleteCribData?.id}/`
        makeDeleteCall(url).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message, "success")
                fetchLocCribs();
            }
        }).catch(emptyFunction)
    }

    const fetchMoreData = () => {
        if (!nextUrl) return;
        makeNextPageCall(nextUrl, false, true).then((res: ApiResponseType<any>) => {
            const data = [...cribsEnteries, ...res.results];
            setCribsEnteries(data);
            setNextUrl(res?.next);
        })
    }

    const handleApply = async (selectedData: any, locationId: any) => {
        if (!selectedData?.id) {
            showToast('Please add at least one production', 'error');
            return
        }
        const payload = {
            production_company_id: selectedData?.production_company?.id,
            location_vault_id: locationId
        }
        const toastId = toast.loading('Duplicating location vault...', {
            position: 'bottom-right',
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
        });
        setShowAddProd(false)
        const res: ApiResponseType<any> = await makePostCall(endPoints.DUPLICATE_LOCATION_VAULT, payload, false, true);
        toast.dismiss(toastId);
        if (res?.status?.code == 200) {
            showToast(res?.status?.message, 'success');
            fetchLoc();
        }
    }

    useEffect(() => {
        if (locationId) {
            if (subTab == 'info') {
                fetchLoc();
                return
            }
            if (subTab == 'crib') {
                fetchLocCribs();
                return
            }
        }
    }, [locationId, subTab]);

    return (
        <SideBarLayout>
            <div className="right-content-full-screen">

                <div className={(editCribData || editLocationData?.id) ? 'ld-page-no-scroll' : "ld-page"}>

                    <div className="ld-header">
                        <div className="ld-header__left">
                            <h1 className="ld-header__title">{locationData?.name || ''}</h1>
                            <div className="ld-breadcrumb">
                                <button className="ld-breadcrumb__link" onClick={() => navigate(vaultType === 'myvault' ? '/location/myvault' : '/location/vault')}>
                                    {vaultType === 'myvault' ? "My Vault" : 'Location Vault'}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <span className="ld-breadcrumb__current">{locationData?.name || ''}</span>
                            </div>
                        </div>

                        <DetailsHeaderTabs
                            setTopTab={(type: any) => {
                                const route = handleTabs(type);
                                setTopTab(type)
                                if (route) {
                                    navigate(`${route}/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: { ...locationData, role: location?.role, can_view_location: location?.can_view_location || canViewLocation } },
                                    });
                                }
                            }}
                            topTab={topTab}
                        />

                        <div className="ld-header__actions">
                            {!props?.hideAsign &&
                                <>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            setAsignLocCollection({ location: locationData, id: locationId })
                                        }}
                                        className="ld-btn-assign"
                                    >
                                        Assign Location
                                    </button>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            setAsignLocToScript({ location: locationData, id: locationId })
                                        }}
                                        className="ld-btn-assign"
                                    >
                                        Assign to script
                                    </button>
                                </>
                            }
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-icon"
                                aria-label="Share"
                            >
                                <img src="/assets/images/upload-share-icon.svg" alt="Share" />
                            </button>
                        </div>
                    </div>

                    <LocationInfo
                        locationData={locationData}
                        updateCrib={setEditCribData}
                        updateLoc={() => setEditLocationData(locationData)}
                        deleteCrib={setDeleteCribData}
                        setSubTab={setSubTab}
                        subTab={subTab}
                        cribsEnteries={cribsEnteries}
                        fetchMoreData={fetchMoreData}
                        nextUrl={nextUrl}
                        onAddCrib={() => setEditCribData({ id: '' })}
                        role={location?.role}
                        canViewLocation={location?.can_view_location}
                        addLocTags={() => setShowTagsModal(true)}
                        addProd={() => setShowAddProd(true)}
                        vaultType={vaultType}
                        onEditTag={() => setShowTagsModal(true)}
                    />

                    {editLocationData &&
                        <UpdateLocation
                            locationData={locationData}
                            onClose={() => setEditLocationData(null)}
                            onUpdate={fetchLoc}
                        />
                    }
                    {editCribData &&
                        <UpdateCrib
                            onClose={() => setEditCribData(null)}
                            cribData={editCribData}
                            cribEntries={cribsEnteries}
                            handleEdit={setEditCribData}
                            onDelete={setDeleteCribData}
                            onUpdate={fetchLocCribs}
                            locationID={locationData?.id}
                        />
                    }

                    {deleteCribData &&
                        <DeleteCribSheetPopup
                            onClose={() => {
                                setDeleteCribData(null);
                            }}
                            onDelete={handleDelete}
                        />
                    }

                    {showTagsModal &&
                        <AddTagsPopUp
                            onClose={() => setShowTagsModal(false)}
                            onDone={fetchLoc}
                            locationData={locationData}
                        />
                    }

                    {showAddProd &&
                        <AsignLocationToProd
                            onClose={() => setShowAddProd(false)}
                            onDone={handleApply}
                            locationData={{ id: locationVaultId }}
                        />
                    }

                    {asignLocCollection?.id &&
                        <AsignLocationToCollection
                            onClose={() => setAsignLocCollection(null)}
                            onCreate={() => {
                                setAsignLocCollection(null);
                                setShowCreateCollection(true)
                            }}
                            locationData={asignLocCollection}
                            production_company_name={getCompanyName(userData)}
                        />
                    }

                    {asignLocToScript?.id &&
                        <AsignLocationToPerScript
                            onClose={() => setAsignLocToScript(null)}
                            onCreate={() => {
                                setAsignLocToScript(null);
                            }}
                            locationData={asignLocToScript}
                            production_company_name={getCompanyName(userData)}
                        />
                    }

                    {showCreateCollection &&
                        <CreateCollections
                            onClose={() => setShowCreateCollection(false)}
                            onDone={() => {
                                setShowCreateCollection(false)
                            }}
                        />
                    }

                </div>
            </div>
        </SideBarLayout>
    );
};

export default LocationDetail;